import { useQuery } from '@tanstack/react-query';
import { type GetDocumentsRenderedRequestType, getDocumentRendered } from '..';
import { queryKey } from './query-key';

export const useGetDocumentRendered = (
  params: GetDocumentsRenderedRequestType,
) =>
  useQuery(
    queryKey.rendered(params.documentId),
    () => getDocumentRendered(params),
    {
      enabled: Boolean(params.documentId),
      cacheTime: 0,
      staleTime: 0,
    },
  );
